import { MOONPAY_HOSTS } from "@connect/data/common/hosts";

export const THREE_DS_COMPLETE_MESSAGE = "payment-authentication-complete";
export const THREE_DS_FAILURE_MESSAGE = "payment-authentication-failure";

// The 3DS page is served by the public API, and its return page posts the result from that origin.
export const THREE_DS_ALLOWED_ORIGINS: readonly string[] = Object.values(MOONPAY_HOSTS).map(
  ({ api }) => api,
);
